import { ErrorMessage } from "./ErrorMessage";
import { cn } from "@/utils/cn";
import { Field, FieldLabel } from "./ui/field";
import { Textarea } from "./ui/textarea";
import { AIShimmerOverlay } from "./ai/ai-info-extractor/ai-shimmer-overlay";

interface TextAreaProps {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  name: string;
  placeholder: string;
  error?: string;
  className?: string;
  rootClassName?: string;
  showAIShimmer?: boolean;
}

const TextArea = ({
  label,
  value,
  onChange,
  name,
  placeholder,
  error,
  className,
  rootClassName,
  showAIShimmer = false,
}: TextAreaProps) => {
  return (
    <Field className={rootClassName}>
      <FieldLabel>{label}</FieldLabel>
      <AIShimmerOverlay show={showAIShimmer}>
        <Textarea
          className={cn("min-h-36", className)}
          value={value}
          onChange={onChange}
          name={name}
          placeholder={placeholder}
        />
      </AIShimmerOverlay>
      {error && (
        <ErrorMessage text={error} className="text-xs!" wrapperClassName="items-start! justify-start! p-0! h-auto!" />
      )}
    </Field>
  );
};

export { TextArea };
